
declare global {
  interface Window {
    PLATFORM_INSTANCE: any
    CUSTOMER_DOMAIN: any
    PARTNER_DOMAIN:any
  }
}

export interface FrontConfig {
  debug: boolean
  backend: {
    url: string
  }
  graphql: {
    url: string
  }
  keycloak: {
    PARTNER: {
      authServerUrl: string
      realm: string
      clientId: string
      idpHint?: string
      init: {
        onLoad: string
        flow: string
        checkLoginIframe: boolean
        silentCheckSsoRedirectUri: string
        enableLogging: boolean
      }
    },
    CUSTOMER: {
      authServerUrl: string
      realm: string
      clientId: string
      idpHint?: string
      init: {
        onLoad: string
        flow: string
        checkLoginIframe: boolean
        silentCheckSsoRedirectUri: string
        enableLogging: boolean
      }
    }
  }
}

interface ConfigInstances {
  development: FrontConfig
  staging: FrontConfig,
  production: FrontConfig

}

const CONFIG_INSTANCES: ConfigInstances = {
  development: {
    debug: true,
    backend: {
      url: 'http://localhost:3333'
    },
    graphql: {
      url: 'http://localhost:3333/graphql'
    },
    keycloak: {
      PARTNER: {
        authServerUrl: 'https://auth.staging.betrue.fr/auth/',
        realm: 'betrue-staging',
        clientId: 'factory',
        init: {
          onLoad: 'check-sso',
          flow: 'implicit',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
          enableLogging: true
        }
      },
      CUSTOMER: {
        authServerUrl: 'https://auth.staging.betrue.fr/auth/',
        realm: 'betrue-staging',
        clientId: 'factory',
        idpHint: 'keycloak-oidc',
        init: {
          onLoad: 'check-sso',
          flow: 'implicit',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
          enableLogging: true
        }
      }
    }
  },
  production: {
    debug: false,
    backend: {
      url: 'https://portal.betrue.fr/graphql-api'
    },
    graphql: {
      url: 'https://portal.betrue.fr/graphql-api/graphql'
    },
    keycloak: {
      PARTNER: {
        authServerUrl: 'https://auth.betrue.fr/auth/',
        realm: 'betrue',
        clientId: 'factory',
        idpHint: "partner",
        init: {
          onLoad: 'check-sso',
          flow: 'implicit',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/wp-content/plugins/elementor-widgets/dist/assets/silent-check-sso.html',
          enableLogging: true
        }
      },
      CUSTOMER: {
        authServerUrl: 'https://auth.betrue.fr/auth/',
        realm: 'betrue',
        clientId: 'factory',
        idpHint: "client",
        init: {
          onLoad: 'check-sso',
          flow: 'implicit',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/wp-content/plugins/elementor-widgets/dist/assets/silent-check-sso.html',
          enableLogging: true
        }
      }
    }
  },
  staging: {
    debug: false,
    backend: {
      url: 'https://portal.staging.betrue.fr/graphql-api'
    },
    graphql: {
      url: 'https://portal.staging.betrue.fr/graphql-api/graphql'
    },
    keycloak: {
      PARTNER: {
        authServerUrl: 'https://auth.staging.betrue.fr/auth/',
        realm: 'betrue-staging',
        clientId: 'factory',
        init: {
          onLoad: 'check-sso',
          flow: 'implicit',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/wp-content/plugins/elementor-widgets/dist/assets/silent-check-sso.html',
          enableLogging: true
        }
      },
      CUSTOMER: {
        authServerUrl: 'https://auth.staging.betrue.fr/auth/',
        realm: 'betrue-staging',
        clientId: 'factory',
        idpHint: 'keycloak-oidc',
        init: {
          onLoad: 'check-sso',
          flow: 'implicit',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri: window.location.origin + '/wp-content/plugins/elementor-widgets/dist/assets/silent-check-sso.html',
          enableLogging: true
        }
      }
    }
  }
}

const env = process.env['NODE' + '_ENV'] ? process.env['NODE' + '_ENV'] : 'development'


console.log('CURRENT ENV', env)

export const CONFIG: FrontConfig = CONFIG_INSTANCES[env]
export const KEYCLOAK_CONFIG = () => {
  if(!window.PLATFORM_INSTANCE){
    window.location.href = '/config-error?msg=no platform instance'
  }
  return CONFIG.keycloak[window.PLATFORM_INSTANCE]
}
